// extracted by mini-css-extract-plugin
module.exports = {"arrow":"CarouselScrollArrow_arrow___GAVH"};